/**
 * Pure reaction delta applicator — shared by the REST toggle path and the
 * Realtime `onReaction` listener so both stay in lockstep.
 */
import type { ChatMessage } from '../services/chat/chatApi';

export interface ReactionDelta {
  messageId: string;
  userId: string;
  emoji: string;
  action: 'add' | 'remove';
}

export function applyReactionToMessages(
  messagesByGroup: Record<string, ChatMessage[]>,
  evt: ReactionDelta,
): Record<string, ChatMessage[]> {
  const next: Record<string, ChatMessage[]> = {};
  for (const [gid, list] of Object.entries(messagesByGroup)) {
    next[gid] = list.map((m) => {
      if (m.id !== evt.messageId) return m;
      const reactions = (m.reactions ?? []).filter(
        (r) => !(r.userId === evt.userId && r.emoji === evt.emoji),
      );
      if (evt.action === 'add') reactions.push({ userId: evt.userId, emoji: evt.emoji });
      return { ...m, reactions };
    });
  }
  return next;
}
